<template>
    <div class="story-maker-sticker story-maker-sticker-music" :class="{edit : isEditing}">
        
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')">
        <p class="text-finish" @click="finish">{{ $t('dash.post-creator.story.done') }}</p>
        <i class="fa-solid fa-trash trash" @click="deleteMusic"></i>

        <div 
            class="sticker sticker-music"
            :class="[`color-${models.color.slice(1).toUpperCase()}`]"
            :style="{ 
                backgroundColor: models.color,
                top: `${$attrs.position.y}%`, 
                left: `${$attrs.position.x}%`,
                transform: isCover || isPreventCover ? `translate(-50%, -50%) scale(${$attrs.transform.scale}) rotate(${$attrs.transform.rotate}deg)` : ''
            }"
        >

        <template v-if="styleVariant">
           <div v-if="styleVariant == 1" class="card-style">
                <img :src="music.track ? music.track.cover_artwork_thumbnail_uri : music.original_sound.ig_artist.profile_pic_url" alt="" class="selectDisable" draggable="false">
                <div class="info-music">
                    <p class="name">{{music.track ? music.track.title : music.original_sound.original_audio_title }}</p>
                    <p class="author">{{music.track ? music.track.display_artist : music.original_sound.ig_artist.full_name }}</p>
                </div>
           </div>

           <div v-else-if="styleVariant == 2"  class="square-style">
                <div class="image">
                    <img :src="music.track ? music.track.cover_artwork_thumbnail_uri : music.original_sound.ig_artist.profile_pic_url" alt="" class="selectDisable" draggable="false"></img>
                    <div class="sound-effect"></div>
                </div>
               
                <div class="info-music">
                    <p class="name">{{music.track ? music.track.title : music.original_sound.original_audio_title }}</p>
                    <p class="author">{{music.track ? music.track.display_artist : music.original_sound.ig_artist.full_name }}</p>
                </div>
           </div>

            <div v-else-if="styleVariant == 3" class="disc-style">
                <div class="disc">
                    <img :src="music.track ? music.track.cover_artwork_thumbnail_uri : music.original_sound.ig_artist.profile_pic_url" alt="" class="selectDisable" draggable="false"></img>
                </div>
               
                <div class="info-music">
                    <p class="name">{{music.track ? music.track.title : music.original_sound.original_audio_title }}</p>
                    <p class="author">{{music.track ? music.track.display_artist : music.original_sound.ig_artist.full_name }}</p>
                </div>
           </div>
        </template>

        </div>

        <div class="container-options" v-if="isEditing">
            <div class="styles" v-if="false">
                <div :class="['style', `${value}-style`, {active: index == styleVariant}]" @click="changeStyleVariant(index)" v-for="(value, index) in ['empty','card', 'square','disc']"></div>
            </div>
            <CursorMusic 
                :music="music"
                :defaultRangeDuration="models.rangeDuration"
                :defaultStart="models.start"
                :durationLock="
                    $attrs.backgroundFileId && $attrs.files[$attrs.backgroundFileId].info.type.startsWith('video/') ?
                    Math.min(60, Math.ceil($attrs.files[$attrs.backgroundFileId].info.duration)) 
                    : null
                "
                @rangeDurationChange="models.rangeDuration = $event"
                @startChange="models.start = $event"
            />
        </div>
        <!-- <div class="sticker-music">
           <div class="icon"></div>
            {{ music.track.title ? music.track.title : '' }}
        </div> -->
    </div>
</template>

<script>

import CursorMusic from '../../../cursorMusic.vue';
import { EventBus } from '@/event-bus';

export default {
    components: {
        CursorMusic,
    },
    props: {
        id: Number | String,
        music: Object,
        styleVariant: {
            type: Number,
            default: 0
        },
        start: Number,
        rangeDuration: Number,


        isEditing: Boolean,
        isPreventCover: Boolean,
        isCover: Boolean,
        setCover: Function,
        setCbClick: Function,
    },
    
    data() {
        return {
            timeoutFinish: null,
            models : {
                rangeDuration: this.rangeDuration ? this.rangeDuration.toString() : '15000',
                start: this.start || 0,
                color: '',
            }            
        }
    },

    mounted () {
        //if (this.isEditing) this.playMusic()
        EventBus.$on('storyMaker-confirmEditingSticker', this.saveCurrentState);
    },

    methods: {
        clickSticker() {
            if (this.isEditing) return 
            this.setCover(true)
            this.$nextTick(()=> {
                this.$emit('updateSticker',this.id , {
                    isEditing: true
                })   
            })
        },

        saveCurrentState() {
            if (!this.isEditing) return;
            this.$emit('updateSticker', this.id, {
                isEditing: false,
                data: {
                    music: this.music,
                    rangeDuration: Math.min(45000, parseInt(this.models.rangeDuration)),
                    start: this.models.start,
                    styleVariant: this.styleVariant,
                }
            });
            if (this.timeoutFinish) clearTimeout(this.timeoutFinish);
            this.timeoutFinish = setTimeout(() => { this.setCover(false); }, 200);
        },

        finish() {
            this.saveCurrentState();
        },

        changeStyleVariant(index) {
            this.$emit('updateSticker',this.id , {
                data : {
                    ...this.$attrs.data,
                    styleVariant : index
                },
            })
        },

        deleteMusic() {
            this.$emit('deleteSticker',this.id)
        }
    },

    beforeDestroy() {
        EventBus.$off('storyMaker-confirmEditingSticker', this.saveCurrentState);
    },

    watch: {
        isEditing: {
            handler(newValue) {
                if (newValue && !this.isPreventCover && !this.isCover) {
                    this.isEditing = false
                    this.clickSticker()
                }
            },
            immediate: true
        },
    },


}
</script>
